import { render, staticRenderFns } from "./RecipeFilterChips.vue?vue&type=template&id=64b55c4a&"
import script from "./RecipeFilterChips.vue?vue&type=script&lang=js&"
export * from "./RecipeFilterChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports